import React, { lazy, Suspense } from 'react'
import { LoadingSplashScreen } from '@the-game/components'

const LazyCallbackComponent = lazy(() => import('./CallbackComponent'))
export function CallbackComponent() {
    return (
        <Suspense fallback={<LoadingSplashScreen />}>
            <LazyCallbackComponent />
        </Suspense>
    )
}

const LazyNotAuthenticatedComponent = lazy(
    () => import('./NotAuthenticatedComponent'),
)

export function NotAuthenticatedComponent() {
    return (
        <Suspense fallback={<LoadingSplashScreen />}>
            <LazyNotAuthenticatedComponent />
        </Suspense>
    )
}

const LazySessionLostComponent = lazy(() => import('./SessionLostComponent'))
export function SessionLostComponent() {
    return (
        <Suspense fallback={<LoadingSplashScreen />}>
            <LazySessionLostComponent />
        </Suspense>
    )
}
